/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

export const NoOfCountRecord = ({ perPage, totalItem, page }: any) => {
  const paginationText = useMemo(() => {
    const startItem = (page - 1) * perPage + 1;
    const endItem = Math.min(page * perPage, totalItem);
    return { startItem, endItem };
  }, [page, perPage, totalItem]);

  return (
    <div className="min-w-max inline-block pr-3 text-sm my-4 md:my-0">
      <span className="text-slate-400 pr-2">Showing</span>
      {paginationText.startItem} - {paginationText.endItem}
      <span className="text-slate-400 pl-2 pr-2">from</span>
      {totalItem} <span className="text-slate-400 pl-1">records</span>
    </div>
  );
};
